function initPartnerHubs() {
    var $listing = $('#partner-hubs-listing');
    if ($listing.length) {
        loadPartnerHubs($listing);
    }

    var $detail = $('#partner-hub-detail');
    if ($detail.length) {
        var slug = $detail.data('slug');
        if (slug) {
            loadPartnerHubDetail($detail, slug);
        }
    }

    var $contentDetail = $('#partner-hub-content-detail');
    if ($contentDetail.length) {
        var hubSlug = $contentDetail.data('slug');
        var contentSlug = $contentDetail.data('content-slug');
        if (hubSlug && contentSlug) {
            loadPartnerHubContent($contentDetail, hubSlug, contentSlug);
        }
    }
}

$(document).ready(initPartnerHubs);

window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
        initPartnerHubs();
    }
});

/**
 * Escurece/clareia um hex (#rrggbb) em `percent` (-100..100).
 */
function shadeColor(hex, percent) {
    var color = String(hex || '').replace('#', '');
    if (color.length === 3) {
        color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
    }
    if (!/^[0-9a-fA-F]{6}$/.test(color)) {
        return null;
    }

    var num = parseInt(color, 16);
    var amt = Math.round(2.55 * percent);
    var channels = [num >> 16, (num >> 8) & 0x00ff, num & 0x00ff].map(function (value) {
        return Math.max(0, Math.min(255, value + amt));
    });

    return 'rgb(' + channels.join(',') + ')';
}

/**
 * Gradiente do placeholder de material: cor do header no topo,
 * fade pra preto na base.
 */
function placeholderGradient(headerColor) {
    var base = headerColor || '#006bbd';
    return 'linear-gradient(to bottom, ' + base + ' 0%, #000000 100%)';
}

/**
 * Aplica a cor escolhida pelo hub como background do header global do site
 * (.main-menu-top) e também dos botões laterais do menu de contato. Só é
 * chamada nas páginas de detalhe do hub.
 */
function applyHubHeaderColor(color) {
    if (!color) return;
    $('.home-menu .main-menu-top').css('background-color', color);
    $('.menu-contact-user .intro .btn-contact').css('background-color', color);
    $('.menu-contact .intro .btn-contact').css('background-color', color);
}

function escapeHtml(value) {
    return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

function partnerHubHeaders() {
    var h = Object.assign({}, window.$headerAuth || {});
    var userId = localStorage.getItem('user_id');
    if (userId) {
        h['X-User-Id'] = userId;
    }
    return h;
}

function loadPartnerHubs($container) {
    $.ajax({
        url: '/api/partner-hubs?per_page=50',
        method: 'GET',
        dataType: 'json',
        headers: partnerHubHeaders()
    }).done(function (result) {
        var hubs = result.data || [];
        if (!hubs.length) {
            $container.find('.partner-hubs-grid').html(
                '<div class="partner-hubs-empty">'
                + '<div class="empty-icon"><i class="fas fa-handshake"></i></div>'
                + '<h3>Nenhuma parceria disponível no momento</h3>'
                + '<p>Em breve novas parcerias estarão disponíveis aqui.</p>'
                + '</div>'
            );
            return;
        }

        var cards = hubs.map(function (hub) {
            var description = hub.description
                ? '<p class="hub-card-description">' + hub.description + '</p>'
                : '';

            var highlightsHtml = '';
            if (hub.highlights && hub.highlights.length) {
                var items = hub.highlights.map(function (item) {
                    var title = item.title || '';
                    if (title.length > 40) title = title.substring(0, 40) + '...';
                    return '<div class="highlight-item">'
                        + '<div class="highlight-img"><img src="' + item.image + '" alt="' + (item.title || '') + '"></div>'
                        + '<span class="highlight-title">' + title + '</span>'
                        + '</div>';
                }).join('');

                var dots = '';
                if (hub.highlights.length > 1) {
                    dots = '<div class="carousel-dots">';
                    for (var i = 0; i < hub.highlights.length; i++) {
                        dots += '<span class="dot' + (i === 0 ? ' active' : '') + '" data-index="' + i + '"></span>';
                    }
                    dots += '</div>';
                }

                highlightsHtml = '<div class="hub-highlights">'
                    + '<div class="highlights-track">' + items + '</div>'
                    + dots
                    + '</div>';
            }

            return '<div class="hub-card">'
                + '<h3 class="hub-card-name">' + hub.name + '</h3>'
                + description
                + highlightsHtml
                + '<div class="hub-card-action">'
                + '<a href="/parcerias/' + hub.slug + '" class="btn-saiba-mais">Saiba mais</a>'
                + '</div>'
                + '</div>';
        }).join('');

        $container.find('.partner-hubs-grid').html(cards);

        initCarousels();
    }).fail(function () {
        $container.find('.partner-hubs-grid').html(
            '<div class="partner-hubs-empty"><p>Erro ao carregar parcerias. Tente novamente.</p></div>'
        );
    });
}

function initCarousels() {
    $('.hub-highlights').each(function () {
        var $highlights = $(this);
        var $track = $highlights.find('.highlights-track');
        var $items = $track.find('.highlight-item');
        var $dots = $highlights.find('.dot');

        if ($items.length <= 1) return;

        var currentIndex = 0;

        function goTo(index) {
            currentIndex = index;
            var offset = -(index * 100) + '%';
            $track.css('transform', 'translateX(' + offset + ')');
            $dots.removeClass('active');
            $dots.eq(index).addClass('active');
        }

        $dots.on('click', function () {
            goTo($(this).data('index'));
        });

        var startX = 0;
        var diffX = 0;
        $track.on('touchstart', function (e) {
            startX = e.originalEvent.touches[0].clientX;
            diffX = 0;
        });
        $track.on('touchmove', function (e) {
            diffX = e.originalEvent.touches[0].clientX - startX;
        });
        $track.on('touchend', function () {
            if (Math.abs(diffX) > 40) {
                if (diffX < 0 && currentIndex < $items.length - 1) {
                    goTo(currentIndex + 1);
                } else if (diffX > 0 && currentIndex > 0) {
                    goTo(currentIndex - 1);
                }
            }
        });
    });
}

function loadPartnerHubDetail($container, slug) {
    $.ajax({
        url: '/api/partner-hubs/' + slug,
        method: 'GET',
        dataType: 'json',
        headers: partnerHubHeaders()
    }).done(function (hub) {
        renderHubDetail($container, hub);
    }).fail(function (xhr) {
        if (xhr.status === 404) {
            $container.html('<div class="container" style="padding:60px 0;text-align:center;"><h2>Parceria não encontrada</h2><p><a href="/parcerias">Voltar para parcerias</a></p></div>');
        } else {
            $container.html('<div class="container" style="padding:60px 0;text-align:center;"><p>Erro ao carregar. Tente novamente.</p></div>');
        }
    });
}

function renderHubDetail($container, hub) {
    var headerColor = hub.header_color || '';
    var headerColorStyle = headerColor ? 'color:' + headerColor + ';' : '';

    // Cor do header global (topo com logo Dell) reflete a cor escolhida no hub.
    if (headerColor) {
        applyHubHeaderColor(headerColor);
    }

    var hasLogo = !!hub.image_url;
    var hasDescription = !!(hub.description && String(hub.description).trim());

    // Sem logo e sem descrição o background ocupa o card inteiro.
    var backgroundOnly = !hasLogo && !hasDescription && !!hub.background_image_url;

    var hasOverlay = hasLogo || hasDescription;

    var bgImage = hub.background_image_url
        ? '<img class="partner-hub-hero-bg" src="' + hub.background_image_url + '" alt="' + escapeHtml(hub.name) + '">'
        : '';

    var overlayHtml = hasOverlay ? '<div class="partner-hub-hero-overlay"></div>' : '';

    var infoHtml = '';
    if (hasLogo || hasDescription) {
        var logo = hasLogo
            ? '<div class="partner-hub-hero-logo"><img src="' + hub.image_url + '" alt="' + escapeHtml(hub.name) + '"></div>'
            : '';

        infoHtml = '<div class="partner-hub-hero-info">'
            + logo
            + (hasDescription ? '<p class="partner-hub-hero-headline">' + hub.description + '</p>' : '')
            + '</div>';
    }

    var heroHtml = ''
        + '<div class="partner-hub-hero">'
        + '<div class="container">'
        + '<div class="partner-hub-hero-card">'
        + bgImage
        + overlayHtml
        + infoHtml
        + '</div>'
        + '</div>'
        + '</div>';

    var hasContents = !!(hub.contents && hub.contents.length);
    var sideBanners = hub.side_banners || [];

    var contentsHtml = '';
    if (hasContents || sideBanners.length) {
        var contentCards = (hub.contents || []).map(function (content) {
            var mediaHtml = '';
            if (content.images && content.images.length && content.images[0].url) {
                mediaHtml = '<div class="content-card-media"><img src="' + content.images[0].url + '" alt="' + escapeHtml(content.title) + '">'
                    + (content.video_url ? '<span class="content-card-video"><i class="fas fa-play"></i></span>' : '')
                    + '</div>';
            }

            var excerpt = '';
            if (content.content) {
                var tmp = document.createElement('div');
                tmp.innerHTML = content.content;
                excerpt = tmp.textContent || tmp.innerText || '';
                if (excerpt.length > 220) excerpt = excerpt.substring(0, 220) + '...';
            }

            var href = '/parcerias/' + hub.slug + '/' + content.slug;

            return ''
                + '<a href="' + href + '" class="content-card">'
                + mediaHtml
                + '<div class="content-card-body">'
                + '<h3>' + escapeHtml(content.title) + '</h3>'
                + (excerpt ? '<p>' + escapeHtml(excerpt) + '</p>' : '')
                + '</div>'
                + '</a>';
        }).join('');

        // Banners de campanha/institucional — já vêm filtrados e ordenados da API.
        var fixedImagesHtml = '';
        if (sideBanners.length) {
            var bannerItems = sideBanners.map(function (banner) {
                var img = '<img src="' + banner.image + '" alt="">';
                var typeClass = ' contents-fixed-image--' + (banner.type || 'institutional');
                if (banner.url) {
                    var target = banner.external ? ' target="_blank" rel="noopener"' : '';
                    return '<a class="contents-fixed-image' + typeClass + '" href="' + banner.url + '"' + target + '>' + img + '</a>';
                }
                return '<div class="contents-fixed-image' + typeClass + '">' + img + '</div>';
            }).join('');

            fixedImagesHtml = '<div class="contents-fixed-images">' + bannerItems + '</div>';
        }

        var contentsMain = hasContents
            ? '<div class="contents-main">'
                + '<div class="contents-header">'
                + '<h2>Conteúdos para você</h2>'
                + '<div class="border"></div>'
                + '</div>'
                + '<div class="contents-list">' + contentCards + '</div>'
                + '</div>'
            : '';

        contentsHtml = ''
            + '<div class="partner-hub-contents">'
            + '<div class="container">'
            + '<div class="contents-layout' + (hasContents ? '' : ' is-banners-only') + '">'
            + fixedImagesHtml
            + contentsMain
            + '</div>'
            + '</div>'
            + '</div>';
    }

    var materialsHtml = '';
    var isMaterialsScrollable = hub.materials && hub.materials.length > 4;
    if (hub.materials && hub.materials.length) {
        var gradient = placeholderGradient(hub.header_color);

        var materialCards = hub.materials.map(function (material) {
            // Sem imagem, o card usa um placeholder em gradiente da cor do header.
            var mediaHtml = material.image
                ? '<div class="material-image"><img src="' + material.image + '" alt="' + escapeHtml(material.title) + '"></div>'
                : '<div class="material-image is-placeholder" style="background:' + gradient + ';">'
                    + '<img src="/img/material-placeholder.svg" alt="">'
                    + '</div>';

            var downloadIcon = material.catalog
                ? '<img src="/img/download.png" alt="" class="material-download">'
                : '';

            var cardContent = mediaHtml
                + '<div class="material-info">'
                + downloadIcon
                + '<span>' + escapeHtml(material.title) + '</span>'
                + '</div>';

            if (material.catalog) {
                return '<a href="' + material.catalog + '" target="_blank" class="material-card">' + cardContent + '</a>';
            }
            return '<div class="material-card">' + cardContent + '</div>';
        }).join('');

        var materialsNavPrev = isMaterialsScrollable
            ? '<button type="button" class="materials-nav-arrow materials-nav-prev" aria-label="Material anterior">&#10094;</button>'
            : '';
        var materialsNavNext = isMaterialsScrollable
            ? '<button type="button" class="materials-nav-arrow materials-nav-next" aria-label="Próximo material">&#10095;</button>'
            : '';

        var materialsDots = isMaterialsScrollable
            ? '<div class="materials-dots">' + hub.materials.map(function (m, i) {
                return '<span class="dot' + (i === 0 ? ' active' : '') + '" data-index="' + i + '"></span>';
            }).join('') + '</div>'
            : '';

        materialsHtml = ''
            + '<div class="partner-hub-materials">'
            + '<div class="container">'
            + '<div class="materials-header">'
            + '<h2>Materiais disponíveis</h2>'
            + '</div>'
            + '<div class="materials-list-wrapper' + (isMaterialsScrollable ? ' is-scrollable' : '') + '">'
            + materialsNavPrev
            + '<div class="materials-list">' + materialCards + '</div>'
            + materialsNavNext
            + '</div>'
            + materialsDots
            + '</div>'
            + '</div>';
    }

    $container.html(heroHtml + materialsHtml + contentsHtml);

    if (isMaterialsScrollable) {
        initMaterialsScroller($container);
    }
}

function initMaterialsScroller($container) {
    var $list = $container.find('.materials-list');
    var listEl = $list.get(0);
    var $dots = $container.find('.materials-dots .dot');
    var $cards = $list.find('.material-card');
    var cardEls = $cards.get();
    var $prevBtn = $container.find('.materials-nav-prev');
    var $nextBtn = $container.find('.materials-nav-next');

    function maxScrollLeft() {
        return Math.max(0, listEl.scrollWidth - listEl.clientWidth);
    }

    // scrollLeft necessário para alinhar o card ao início (ou ao centro, no
    // mobile) da área visível. Baseado em getBoundingClientRect em vez de
    // offsetLeft: offsetLeft é relativo ao offsetParent e inclui a margem
    // lateral do container centralizado, o que deslocava o alvo do scroll —
    // por isso as setas "pulavam" vários cards e o snap "recentralizava"
    // depois de meio segundo. O rect é sempre relativo à própria lista.
    function rawTargetFor(cardEl) {
        var padLeft = parseInt(getComputedStyle(listEl).paddingLeft) || 0;
        var target = listEl.scrollLeft + cardEl.getBoundingClientRect().left - listEl.getBoundingClientRect().left - padLeft;
        if (getComputedStyle(cardEl).scrollSnapAlign === 'center') {
            target -= (listEl.clientWidth - cardEl.offsetWidth) / 2;
        }
        return target;
    }

    function targetFor(cardEl) {
        return Math.max(0, Math.min(rawTargetFor(cardEl), maxScrollLeft()));
    }

    function currentIndex() {
        var closestIndex = 0;
        var closestDistance = Infinity;
        cardEls.forEach(function (cardEl, index) {
            var distance = Math.abs(targetFor(cardEl) - listEl.scrollLeft);
            if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
            }
        });
        return closestIndex;
    }

    // Quando vários cards cabem por vez (desktop), não é possível alinhar os
    // últimos índices à esquerda — o navegador trava no scroll máximo real.
    function maxReachableIndex() {
        var maxScroll = maxScrollLeft();
        var best = 0;
        cardEls.forEach(function (cardEl, index) {
            if (rawTargetFor(cardEl) <= maxScroll + 1) best = index;
        });
        return best;
    }

    function syncNav(index) {
        $dots.removeClass('active').eq(index).addClass('active');
        $prevBtn.toggleClass('is-boundary-hidden', index <= 0);
        $nextBtn.toggleClass('is-boundary-hidden', index >= maxReachableIndex());
    }

    var activeIndex = currentIndex();
    var isNavigating = false;

    function goToIndex(index) {
        index = Math.max(0, Math.min(index, maxReachableIndex()));
        activeIndex = index;
        isNavigating = true;
        var cardEl = cardEls[index];
        if (cardEl) {
            listEl.scrollTo({ left: targetFor(cardEl), behavior: 'auto' });
        }
        syncNav(index);
    }

    $nextBtn.on('click', function () {
        goToIndex(activeIndex + 1);
    });

    $prevBtn.on('click', function () {
        goToIndex(activeIndex - 1);
    });

    $dots.on('click', function () {
        goToIndex($(this).data('index'));
    });

    var scrollTimeout;
    listEl.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
            if (isNavigating) {
                isNavigating = false;
                return;
            }
            activeIndex = currentIndex();
            syncNav(activeIndex);
        }, 100);
    });

    syncNav(activeIndex);
}

function loadPartnerHubContent($container, hubSlug, contentSlug) {
    $.ajax({
        url: '/api/partner-hubs/' + hubSlug + '/contents/' + contentSlug,
        method: 'GET',
        dataType: 'json',
        headers: partnerHubHeaders()
    }).done(function (content) {
        renderContentDetail($container, content);
    }).fail(function (xhr) {
        if (xhr.status === 404) {
            $container.html('<div class="container" style="padding:60px 0;text-align:center;"><h2>Conteúdo não encontrado</h2><p><a href="/parcerias/' + hubSlug + '">Voltar para a parceria</a></p></div>');
        } else {
            $container.html('<div class="container" style="padding:60px 0;text-align:center;"><p>Erro ao carregar. Tente novamente.</p></div>');
        }
    });
}

function renderContentDetail($container, content) {
    var hub = content.hub || {};
    var hubHref = '/parcerias/' + hub.slug;
    var headerColor = hub.header_color || '#006bbd';

    if (hub.header_color) {
        applyHubHeaderColor(hub.header_color);
    }

    var hubMark = hub.image_url
        ? '<img class="content-detail-hub-logo" src="' + hub.image_url + '" alt="' + escapeHtml(hub.name) + '">'
        : '<span class="content-detail-hub-name" style="color:' + headerColor + ';">' + escapeHtml(hub.name) + '</span>';

    // Player exibido direto na página quando o conteúdo tem vídeo.
    var posterAttr = (content.images && content.images.length && content.images[0].url)
        ? ' poster="' + content.images[0].url + '"'
        : '';

    var videoHtml = content.video_url
        ? '<div class="content-detail-video">'
            + '<video controls preload="metadata"' + posterAttr + ' src="' + content.video_url + '"></video>'
            + '</div>'
        : '';

    // Com vídeo, a primeira imagem vira poster e não se repete na galeria.
    var galleryImages = (content.images || []).filter(function (image) {
        return image && image.url;
    });
    if (content.video_url && galleryImages.length) {
        galleryImages = galleryImages.slice(1);
    }

    var galleryHtml = galleryImages.length
        ? '<div class="content-detail-gallery">'
            + galleryImages.map(function (image) {
                return '<img src="' + image.url + '" alt="">';
            }).join('')
            + '</div>'
        : '';

    $container.html(''
        + '<div class="content-detail-wrapper">'
        + '<div class="container">'
        + '<div class="content-detail-top">'
        + '<a class="content-detail-back" href="' + hubHref + '">&#10094; Voltar para ' + escapeHtml(hub.name) + '</a>'
        + hubMark
        + '</div>'
        + '<article class="content-detail-card">'
        + '<h1 class="content-detail-title">' + escapeHtml(content.title) + '</h1>'
        + (content.date ? '<small class="content-detail-date">' + escapeHtml(content.date) + '</small>' : '')
        + '<div class="content-detail-separator" style="background:' + headerColor + ';"></div>'
        + videoHtml
        + '<div class="content-detail-body">' + (content.content || '') + '</div>'
        + galleryHtml
        + '</article>'
        + '</div>'
        + '</div>'
    );
}
